/**
 * projectsById: {
 *  "1": {project1}
 *  "3": {project3}
 * }
 * allProjectIds: ["3","1"],
 */
export const initialProjectsState = {
    projectsById: {},
    allProjectIds: undefined,
    statisticsByProjectId: {},
};
